export const throttle = (callback, options = {}) => {
  const defaults = { delay: 500 }
  const opts = { ...defaults, ...options }

  let lastCall = 0

  return function (...args) {
    const now = new Date().getTime()
    if (now - lastCall < opts.delay) return
    lastCall = now
    return callback(...args)
  }
}
